import { createAsyncThunk } from '@reduxjs/toolkit'
import Series from './series-model'
import { delete_series, load_seriess, store_series } from './series-service'

export const LoadSeriessAsync = createAsyncThunk<any, any>(
  'composer/load/series',
  async (params: { uid: string }) => {
    return await load_seriess(params)
  },
)

export const CreateSeriesAsync = createAsyncThunk<any, any>(
  'composer/create/series',
  async (params: Series) => {
    return await store_series(params)
  },
)

export const DeleteSeriesAsync = createAsyncThunk<any, any>(
  'composer/delete/series',
  async (params) => {
    return await delete_series(params)
  },
)
